module.exports = __webpack_public_path__ + "components/PaperTile/wk.png?0f81fffd";


//////////////////
// WEBPACK FOOTER
// ./components/PaperTile/wk.png
// module id = 1415
// module chunks = 0